import React, { CSSProperties, useEffect } from 'react';
import type { PortalProps } from '@rc-component/portal';
import { StyledDrawer } from './style';
import { useBreakpoint } from 'utils/useBreakpoint';

export interface DrawerProps {
  open?: boolean;
  title?: React.ReactNode;
  closable?: boolean;
  width?: string | number;
  destroyOnClose?: boolean;
  children?: React.ReactNode;
  onClose?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  footer?: React.ReactNode;
  maskClosable?: boolean;
  style?: CSSProperties;
  headerStyle?: CSSProperties;
  id?: string | undefined;
  getContainer?: PortalProps['getContainer'];
  isCartDrawerOpen?: boolean;
  className?: string;
  closeIcon?: React.ReactNode;
  styled?: boolean;
  zIndex?: number;
}

export const Drawer = ({
  open,
  children,
  title,
  width = '50%',
  destroyOnClose,
  closable = true,
  onClose,
  footer,
  maskClosable,
  style,
  id = undefined,
  headerStyle,
  getContainer,
  isCartDrawerOpen,
  className,
  closeIcon,
  styled,
  zIndex,
}: DrawerProps) => {
  const { isLg } = useBreakpoint();

  const headerStyleGlobal: CSSProperties = isLg
    ? {
        minHeight: 113,
      }
    : {};

  const drawerClassNames = ['drawer'];

  if (className) {
    drawerClassNames.push(className);
  }

  if (styled) {
    drawerClassNames.push('styled-drawer');
  }

  useEffect(() => {
    const appRoot = document.getElementById('app-root');
    if (isCartDrawerOpen) {
      appRoot?.classList.add('no-scroll');
    } else {
      appRoot?.classList.remove('no-scroll');
    }

    return () => appRoot?.classList.remove('no-scroll');
  }, [isCartDrawerOpen]);

  return (
    <StyledDrawer
      className={drawerClassNames.join(' ')}
      closeIcon={closeIcon}
      id={id}
      open={open}
      title={title}
      headerStyle={{ ...headerStyleGlobal, ...headerStyle }}
      width={width}
      destroyOnClose={destroyOnClose}
      closable={closable}
      onClose={onClose}
      getContainer={getContainer || document.getElementById('app-root')!}
      footer={footer}
      maskClosable={maskClosable}
      style={style}
      zIndex={zIndex}
    >
      {children}
    </StyledDrawer>
  );
};
